const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfVariety extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfVariety,
            "Each civilization scores 2 culture for each type of unit, urban building and special (blue) technology.",
            {}
        )
    }
}

module.exports = ImpactOfVariety;